/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import { Link, useLocation } from "react-router-dom";
import { MdKeyboardArrowDown } from "react-icons/md";
import { useState } from 'react';

import SidebarCard from "components/sidebar/componentsrtl/SidebarCard";
import routes from "routes.js";

const Sidebar = ({ open, onClose }) => {
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-green-600 pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-green-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-0 ${
        open ? "translate-x-0" : "-translate-x-96"
      }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden text-white"
        onClick={onClose}
      >
        <HiX />
      </span>

      <div className={`mx-[56px] mt-[50px] flex items-center`}>
        <div className="mt-1 ml-1 h-2.5 font-poppins text-[26px] font-bold uppercase text-white dark:text-white">
          KSA <span className="font-medium"> WEB</span>
        </div>
      </div>
      <div className="mt-[58px] mb-7 h-px bg-white/30" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <SidebarLinks />
      </ul>

      {/* Free Horizon Card */}
      <div className="flex justify-center">
        <SidebarCard />
      </div>

      {/* Nav item end */}
    </div>
  );
};

const SidebarLinks = (props) => {
  const location = useLocation();
  const [openSubmenus, setOpenSubmenus] = useState({});

  const activeRoute = (routePath) => {
    return location.pathname.includes(routePath);
  };

  const toggleSubmenu = (index) => {
    setOpenSubmenus(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return (
    <div className="mt-3 h-full">
      {routes.map((route, index) => {
        // Check if route should be hidden
        const isHidden = typeof route.hidden === 'function' ? route.hidden() : route.hidden;
        if (isHidden) return null;

        const visibleSubmenu = route.submenu?.filter(item => {
          const isItemHidden = typeof item.hidden === 'function' ? item.hidden() : item.hidden;
          return !isItemHidden;
        });
        
        return (
          <div key={index}>
            {route.submenu ? (
              <div 
                onClick={() => toggleSubmenu(index)}
                className={`relative mb-3 flex hover:cursor-pointer`}
              >
                <li className="my-[3px] flex cursor-pointer items-center px-8">
                  <span className={`${activeRoute(route.path) === true ? "font-bold text-white" : "font-medium text-white/70"}`}>
                    {route.icon}
                  </span>
                  <p className={`leading-1 ml-4 flex ${activeRoute(route.path) === true ? "font-bold text-white" : "font-medium text-white/70"}`}>
                    {route.name}
                  </p>
                  <span className="ml-auto transition-transform duration-200 text-white" style={{ transform: openSubmenus[index] ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                    <MdKeyboardArrowDown className="h-5 w-5" />
                  </span>
                </li>
              </div>
            ) : (
              <Link to={route.layout + "/" + route.path}>
                <div className={`relative mb-3 flex hover:cursor-pointer`}>
                  <li className="my-[3px] flex cursor-pointer items-center px-8">
                    <span className={`${activeRoute(route.path) === true ? "font-bold text-white" : "font-medium text-white/70"}`}>
                      {route.icon}
                    </span>
                    <p className={`leading-1 ml-4 flex ${activeRoute(route.path) === true ? "font-bold text-white" : "font-medium text-white/70"}`}>
                      {route.name}
                    </p>
                  </li>
                </div>
              </Link>
            )}
            
            {/* Submenu items */}
            {route.submenu && (
              <div 
                className="ml-8 overflow-hidden transition-all duration-200"
                style={{ 
                  maxHeight: openSubmenus[index] ? '500px' : '0',
                  opacity: openSubmenus[index] ? 1 : 0
                }}
              >
                {visibleSubmenu.map((subRoute, subIndex) => (
                  <Link key={subIndex} to={`${subRoute.layout}/${subRoute.path}`}>
                    <div className="relative mb-2 flex hover:cursor-pointer">
                      <li className="my-[3px] flex cursor-pointer items-center px-4">
                        <span className={`${activeRoute(subRoute.path) === true ? "font-bold text-white" : "font-medium text-white/70"}`}>
                          {subRoute.icon}
                        </span>
                        <p className={`leading-1 ml-3 flex ${activeRoute(subRoute.path) === true ? "font-bold text-white" : "font-medium text-white/70"}`}>
                          {subRoute.name}
                        </p>
                      </li>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Sidebar;
